import { useHotjar } from 'hooks';

const Hotjar = ({ children }) => {
  useHotjar();

  return children;
};

export default Hotjar;
